import { MathUtils, Vector2 } from "three";
import * as THREE from "three";
import { wallColor, wallNormal, wallRoughness } from "./assets/materials";
import { Side, WallSide } from "../entities/OfferItem";
var degToRad = MathUtils.degToRad;
import "../entities/LedExtras";
export class Wall {
    constructor(scene) {
        if (scene.formData.left.wall === true) {
            this.createWall(scene, WallSide.LEFT, 0);
        }
        if (scene.formData.right.wall === true) {
            this.createWall(scene, WallSide.RIGHT, 0);
        }
        if (scene.formData.close.wall === true) {
            this.createWall(scene, WallSide.CLOSE, 2);
        }
        if (scene.formData.far.wall === true) {
            this.createWall(scene, WallSide.FAR, 2);
        }
    }
    createWall(scene, side, offset) {
        let sideDimension;
        let pos;
        const edgeWidth = scene.formData.measuredModel.model.edgeWidth;
        switch (side) {
            case WallSide.LEFT:
                {
                    sideDimension = scene.dimensions.left;
                    pos = sideDimension.position;
                    if (scene.formData.measuredModel.rotated === true)
                        pos.x -= edgeWidth / 2 + 15;
                    else
                        pos.z += edgeWidth / 2 + 15;
                }
                break;
            case WallSide.RIGHT:
                {
                    sideDimension = scene.dimensions.right;
                    pos = sideDimension.position;
                    if (scene.formData.measuredModel.rotated === true)
                        pos.x += edgeWidth / 2 + 15;
                    else
                        pos.z -= edgeWidth / 2 + 15;
                }
                break;
            case WallSide.FAR:
                {
                    sideDimension = scene.dimensions.far;
                    pos = sideDimension.position;
                    if (scene.formData.measuredModel.rotated === true)
                        pos.z -= edgeWidth / 2 + 15;
                    else
                        pos.x -= edgeWidth / 2 + 15;
                }
                break;
            case WallSide.CLOSE: {
                sideDimension = scene.dimensions.close;
                pos = sideDimension.position;
                if (scene.formData.measuredModel.rotated === true)
                    pos.z += edgeWidth / 2 + 15;
                else
                    pos.x += edgeWidth / 2 + 15;
            }
        }
        let wallHeight = 450;
        pos.y = 225;
        if (scene.formData.measuredModel.model.id < 4) {
            wallHeight = 360;
            pos.y = 180;
        }
        const wallWidth = sideDimension.length;
        const wallGeometry = new THREE.BoxGeometry(wallWidth + 60, wallHeight, 30);
        const wallTextureRepeat = new Vector2(wallWidth / 1024 * 2.5, wallHeight / 1024 * 2.5);
        const wallMap = new THREE.Texture();
        const wallRoughnessMap = new THREE.Texture();
        const wallNormalMap = new THREE.Texture();
        scene.assignTexture(wallMap, wallColor);
        scene.assignTexture(wallRoughnessMap, wallRoughness);
        scene.assignTexture(wallNormalMap, wallNormal);
        wallMap.repeat = wallTextureRepeat;
        wallRoughnessMap.repeat = wallTextureRepeat;
        wallNormalMap.repeat = wallTextureRepeat;
        const wallMaterial = new THREE.MeshStandardMaterial({
            polygonOffsetFactor: offset,
            polygonOffset: true,
            metalness: 0.2,
            map: wallMap,
            normalMap: wallNormalMap,
            roughnessMap: wallRoughnessMap,
        });
        const mesh = new THREE.Mesh(wallGeometry, wallMaterial);
        mesh.position.copy(pos);
        mesh.rotateY(degToRad(sideDimension.rotationY));
        scene.threeScene.add(mesh);
    }
    /** Invoked from raycastHandler **/
    selectWall(object, scene, updateFormData) {
        const name = object[0].object.name;
        const offerItem = scene.formData;
        const newRef = new Side();
        let wall;
        switch (name) {
            case "LEFT":
                {
                    if (offerItem.left.wall === true) {
                        wall = new Side(false, offerItem.left.extra);
                    }
                    else {
                        wall = new Side(true, offerItem.left.extra);
                    }
                    Object.assign(newRef, wall);
                    updateFormData({
                        left: newRef
                    });
                }
                break;
            case "RIGHT":
                {
                    if (offerItem.right.wall === true) {
                        wall = new Side(false, offerItem.right.extra);
                    }
                    else {
                        wall = new Side(true, offerItem.right.extra);
                    }
                    Object.assign(newRef, wall);
                    updateFormData({
                        right: newRef
                    });
                }
                break;
            case "CLOSE":
                {
                    if (offerItem.close.wall === true) {
                        wall = new Side(false, offerItem.close.extra);
                    }
                    else {
                        wall = new Side(true, offerItem.close.extra);
                    }
                    Object.assign(newRef, wall);
                    updateFormData({
                        close: newRef
                    });
                }
                break;
            case "FAR":
                {
                    if (offerItem.far.wall === true) {
                        wall = new Side(false, offerItem.far.extra);
                    }
                    else {
                        wall = new Side(true, offerItem.far.extra);
                    }
                    Object.assign(newRef, wall);
                    updateFormData({
                        far: newRef
                    });
                }
                break;
        }
    }
}
